"use strict";
/**
 * @module Services.Authentication
 */
Object.defineProperty(exports, "__esModule", { value: true });
var require_non_null_1 = require("./../../util/require-non-null");
/**
 * Wrapper for a security store update script. Required to provide a unique type
 * to act as a serialisation key.
 */
var SecurityCommandScript = /** @class */ (function () {
    /**
     * Create a new SecurityCommandScript
     *
     * @param script  the script
     */
    function SecurityCommandScript(script) {
        this.script = require_non_null_1.requireNonNull(script, 'script');
    }
    /**
     * Convert object to string
     *
     * @return a string representation of the object
     */
    SecurityCommandScript.prototype.toString = function () {
        return 'SecurityCommandScript [' + this.script + ']';
    };
    return SecurityCommandScript;
}());
exports.SecurityCommandScript = SecurityCommandScript;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/authentication/security-command-script.js
// module id = 821
// module chunks = 1